import { bindable, customElement, resolve } from 'aurelia';
import { I18N } from '@aurelia/i18n';
import template from './share-modal.html';
import { shareDocuments } from '../services/api.service';
import type { SharedUser } from '../services/api.types';

@customElement({ name: 'share-modal', template })
export class ShareModal {
  private readonly i18n: I18N = resolve(I18N);

  @bindable documentIds: string[] = [];
  @bindable saved!: () => void;
  @bindable closed!: () => void;
  @bindable currentUsername: string = '';

  users: SharedUser[] = [];
  saving = false;
  error = '';

  binding(): void {
    // This component may be reused across successive "share" actions — always start clean.
    this.users = [];
    this.saving = false;
    this.error = '';
  }

  get shareSummary(): string {
    return this.i18n.tr('sharing.shareCount', { count: this.documentIds.length });
  }

  async save() {
    if (this.users.length === 0) {
      this.closed();
      return;
    }

    this.saving = true;
    this.error = '';
    try {
      await shareDocuments(this.documentIds, this.users.map(user => user.username));
      this.saved();
    } catch (err) {
      this.error = err instanceof Error ? err.message : 'Share failed';
    } finally {
      this.saving = false;
    }
  }

  cancel() {
    this.closed();
  }
}
